import "./DownloadAirportButton.css";
import * as XLSX from 'xlsx'

function AirportButton() {
    

    const download_airport_names = () =>{
        var url = "api/airportnames";

        fetch(url).then((res) => 
            res.json().then((res) => {
                
                const airports_codes = Object.keys(res.data.airport_names);

                const airports = Object.values(res.data.airport_names);


                let exceldata = []
                for (let i = 0; i < airports.length; i++) {
                    exceldata.push({"Αεροδρόμιο": airports[i], "Κωδικός": airports_codes[i]})
                    
                }
                
                const worksheet = XLSX.utils.json_to_sheet(exceldata);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                XLSX.writeFile(workbook, "Airports.xlsx");


            })
        )
        .catch((error) => {
        console.log("Refetching data for AirportNames!")
        });
    }



    return(
        <button className="download-button" onClick={() => download_airport_names()}>
            <i className="fa fa-download"></i>
            Αεροδρόμια
        </button>

    );
}



export default AirportButton;
